<template>
  <v-app id="app">
    <AppHeader/>
    <v-main role="main" v-if="loaded" :aria-hidden="ariaHideApp">
      <v-container fluid>
        <IeWarning
          v-if="!hideIewWarning"
          class="ieWarning mx-3 mt-3"
          :class="{ sidebarMargin: isApplicationView }"
        />
        <keep-alive include="ApplicationListView">
          <router-view />
        </keep-alive>
      </v-container>
    </v-main>
    <AppSpinner />
    <AppSnackbar />   
  </v-app>
</template>

<script>
import AppHeader from '@/components/app/AppHeader.vue'
import ApplicationListView from '@/views/ApplicationListView.vue'
import ApplicationView from '@/views/ApplicationView.vue'
import IeWarning from '@/components/app/IeWarning.vue'
import AppSnackbar from '@/components/app/AppSnackbar.vue'
import AppSpinner from '@/components/app/AppSpinner.vue'

export default {
  name: 'app',  
  components: {
    AppHeader,
    ApplicationListView,
    ApplicationView,
    IeWarning,
    AppSnackbar
  },
  data() {
    return {
      minutesTimeoutWarning: parseInt(
        process.env.VUE_APP_ACTIVITY_TIMEOUT_WARNING_MINUTES
      ),
      loaded: true,
      ariaHideApp: false,
      isApplicationView: false
    }
  },
  methods: {
    fullScreenModalOpened(value) {
      this.ariaHideApp = value
      if (isWindowsOS() && value) {
        this.hideMainScrollbar()
      } else {
        this.showMainScrollbar()
      }
    },
    hideMainScrollbar() {
      const styleForScrollbar = document.createElement('style')
      styleForScrollbar.id = 'style-for-scrollbar'
      styleForScrollbar.innerHTML =
        'html::-webkit-scrollbar { display: none; } html { scrollbar-width: none; }'
      document.head.appendChild(styleForScrollbar)
    },
    showMainScrollbar() {
      const styleForScrollbar = document.querySelector('#style-for-scrollbar')
      if (styleForScrollbar) {
        document.head.removeChild(styleForScrollbar)
      }
    }
  },
  computed: {
    isShowMessageBox() {
      return this.$store.state.messageBox
    },
    isPostForm() {
      return this.$store.state.postForm
    },
    userID() {
      return this.$store.getters.userID
    }
  },
  beforeCreate() {
    if (false) {
      this.$store.dispatch('showMessageBox', {
        message: 'OFFLINE TEST DATA ACTIVE'
      })
    }

    // We need to pass this information between components
    // so that focus and scroll can be set when the components
    // mount. However they don't need reactivity and attempts at
    // using the Store for this have resulted in the page jumping
    // before setting the correct scroll position. More research
    // to be done on finding a better way...
    window.EA = {
      initialFocusField: null,
      initialFieldOffset: null,
      initialSectionOffset: null
    }
  },
  created() {
    this.$store.dispatch('setCurrentUser')
  },
  beforeMount() {
    this.$activityMonitor.activate()
  },
  beforeDestroy() {
    this.$activityMonitor.deactivate()
  },
  watch: {
    userID(userId) {
      if (!this.loaded && userId && userId !== '') {
        // oauth loaded. Kick off app loading
        this.loaded = true
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        // #DSE-1327: The following fixes an issue with IE11 where the browser was
        // not refreshing a view upon returning to a previous view. The use of
        // browser sniffing is regrettable, but otherwise unavoidable in this
        // instance.
        // Reference: github.com/vuejs/vue-router/issues/1849#issuecomment-427744124
        if (
          '-ms-scroll-limit' in document.documentElement.style &&
          '-ms-ime-align' in document.documentElement.style
        ) {
          // Restrict the forced update to ApplicationListView
          if (to.path === '/') {
            this.$forceUpdate()
          }
        }

        // I know, but ie11 doesn't support .startsWith()
        this.isApplicationView = to.path.indexOf('/application') === 0
        this.hideIewWarning = to.name === 'PrintView'
      }
    }
  }
}
</script>



<style lang="scss">
@import '@/scss/app.scss';
@import '@/scss/variables.scss';
.v-application .ieWarning.sidebarMargin {
  margin-left: calc(#{$desktop-sidebar-width} + 12px) !important;
}
